var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3689 4C12.064 4.00005 12.6035 4.61508 12.5223 5.31445L11.6346 12.9609C11.5656 13.5531 11.0698 13.9998 10.4812 14H5.57988C4.99118 14 4.49556 13.5532 4.42656 12.9609L3.53789 5.31445C3.45669 4.61521 3.99632 4.00028 4.69121 4H11.3689ZM6.84746 7.29102C6.57131 7.29102 6.34746 7.51487 6.34746 7.79102V10.791C6.34754 11.0671 6.57136 11.291 6.84746 11.291C7.12337 11.2908 7.34737 11.067 7.34746 10.791V7.79102C7.34746 7.515 7.12342 7.29123 6.84746 7.29102ZM9.1541 7.29102C8.87795 7.29102 8.6541 7.51487 8.6541 7.79102V10.791C8.65418 11.0671 8.87801 11.291 9.1541 11.291C9.43019 11.291 9.65401 11.0671 9.6541 10.791V7.79102C9.6541 7.51487 9.43024 7.29102 9.1541 7.29102Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49979 2C9.72923 2 9.9295 2.15632 9.98515 2.37891L10.3904 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H3.5C3.22386 5 3 4.77614 3 4.5C3 4.22386 3.22386 4 3.5 4H5.60917L6.01444 2.37891C6.07009 2.15632 6.27036 2 6.49979 2H9.49979ZM6.64042 4H9.35917L9.10917 3H6.89042L6.64042 4Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/Delete2.2024997809ee0225e1083390b88ac88b.svg";
export { ForwardRef as ReactComponent };